const doc = [({"loading":"Laden …", "error":"Ein Fehler ist aufgetreten"})];
module.exports = doc.length <= 1 ? doc[0] : doc;